module.exports = __webpack_public_path__ + "static/img/MvpBg.decba2f6.png";